import { HTMLAttributes } from 'react';
import { Icon, IconName, IconVariant } from '../Graphics';
import styles from './Timeline.module.scss';
import { joinClassNames } from '../../utils';

export type TimelineSegmentProps = HTMLAttributes<HTMLDivElement> & {
  isHighlighted?: boolean;
  label?: string;
  iconName?: IconName;
};

type TimelineDotProps = { radius: number };

const TimelineDot = ({ radius }: TimelineDotProps) => (
  <svg width={radius * 2} height={radius * 2} className={styles.dot}>
    <circle cx={radius} cy={radius} r={radius - 1} />
  </svg>
);

export const TimelineSegment = ({
  children,
  iconName,
  isHighlighted = false,
  label: label,
}: TimelineSegmentProps) => (
  <li className={joinClassNames(styles.timelineSegment, isHighlighted && styles.highlighted)}>
    {label && <div className={joinClassNames(styles.section, styles.date)}>{label}</div>}
    <div className={`${styles.section} ${styles.connector}`}>
      {iconName ? <Icon name={iconName} size="14" variant={IconVariant.Blue} /> : <TimelineDot radius={6} />}
      <span className={joinClassNames(styles.line, iconName !== undefined && styles.iconLine)} />
    </div>
    <div className={styles.section}>{children}</div>
  </li>
);
